import {
  COMMUNICATION_TYPE,
  EXAM_EVALUATION_TYPE,
} from '../../../shared/utils/constants';

const validate = (values) => {
  const errors = {};
  const regexExp = /[\u21b5<p>/]/gi;

  if (!values.title) {
    errors.title = 'Esse campo não pode ficar vazio';
  }
  if (!values.recipients) {
    errors.recipients = 'Selecione os destinatários';
  }
  if (!values.htmlContent) {
    errors.htmlContent = 'Adicione um texto';
  } else if (
    values.htmlContent &&
    values.htmlContent.replace(regexExp, '').length === 1
  ) {
    errors.htmlContent = 'Adicione um texto';
  }
  if (
    values.question &&
    values.question.answers &&
    values.question.answers.length !== 0
  ) {
    if (!values.htmlContent) {
      errors.htmlContent = 'Adicione um texto';
    } else if (
      values.htmlContent &&
      values.htmlContent.replace(regexExp, '').length === 1
    ) {
      errors.htmlContent = 'Adicione um texto';
    }
  }
  if (values.type && values.type === COMMUNICATION_TYPE.ACTIVITY) {
    if (!values.dueDate) {
      errors.dueDate = 'Esse campo não pode ficar vazio';
    }
    if (!values.taskHeader) {
      errors.taskHeader = {};
      errors.taskHeader.teacher = 'Esse campo não pode ficar vazio';
      errors.taskHeader.subject = 'Esse campo não pode ficar vazio';
    } else if (values.taskHeader) {
      errors.taskHeader = {};
      if (!values.taskHeader.teacher) {
        errors.taskHeader.teacher = 'Esse campo não pode ficar vazio';
      }
      if (!values.taskHeader.subject) {
        errors.taskHeader.subject = 'Esse campo não pode ficar vazio';
      }
    }
  }
  if (values.type && values.type === COMMUNICATION_TYPE.EXAM) {
    if (!values.examHeader) {
      errors.examHeader = {};
      errors.examHeader.teacher = 'Esse campo não pode ficar vazio';
      errors.examHeader.subject = 'Esse campo não pode ficar vazio';
      errors.examHeader.cycle = 'Esse campo não pode ficar vazio';
      errors.examHeader.evaluationWay = 'Esse campo não pode ficar vazio';
      errors.examHeader.evaluationType = 'Esse campo não pode ficar vazio';
      errors.examHeader.examType = 'Esse campo não pode ficar vazio';
    } else if (values.examHeader) {
      errors.examHeader = {};
      if (!values.examHeader.teacher) {
        errors.examHeader.teacher = 'Esse campo não pode ficar vazio';
      }
      if (!values.examHeader.subject) {
        errors.examHeader.subject = 'Esse campo não pode ficar vazio';
      }
      if (!values.examHeader.evaluationWay) {
        errors.examHeader.evaluationWay = 'Esse campo não pode ficar vazio';
      }
      if (!values.examHeader.evaluationType) {
        errors.examHeader.evaluationType = 'Esse campo não pode ficar vazio';
      }
      if (!values.examHeader.cycle) {
        errors.examHeader.cycle = 'Esse campo não pode ficar vazio';
      }
      if (values.examHeader.weight <= 0 || values.examHeader.weight > 100) {
        errors.examHeader.weight = 'Esse campo deve ter um valor entre 1 e 100';
      }
      if (!values.examHeader.examType) {
        errors.examHeader.examType = 'Esse campo não pode ficar vazio';
      }
    }
    if (!values.dueDate) {
      errors.examHeader.dueDate = 'Esse campo não pode ficar vazio';
    }
  }

  if (values.type && values.type === COMMUNICATION_TYPE.OCCURRENCE) {
    if (!values.occurrenceHeader) {
      errors.occurrenceHeader = {};
      errors.occurrenceHeader.occurrenceType =
        'Esse campo não pode ficar vazio';
      errors.occurrenceHeader.dueDate = 'Esse campo não pode ficar vazio';
      errors.occurrenceHeader.occurrenceHour =
        'Esse campo não pode ficar vazio';
    } else if (values.occurrenceHeader) {
      errors.occurrenceHeader = {};
      if (!values.occurrenceHeader.occurrenceType) {
        errors.occurrenceHeader.occurrenceType =
          'Esse campo não pode ficar vazio';
      }
      if (!values.occurrenceHeader.dueDate) {
        errors.occurrenceHeader.dueDate = 'Esse campo não pode ficar vazio';
      }
      if (!values.occurrenceHeader.occurrenceHour) {
        errors.occurrenceHeader.occurrenceHour =
          'Esse campo não pode ficar vazio';
      }
    }
  }
  if (
    values.evaluationType &&
    values.evaluationType !== EXAM_EVALUATION_TYPE.CONCEPT
  ) {
    if (values.grade < values.minGrade) {
      errors.grade = `A nota do aluno deve ser maior ou igual a ${values.minGrade}`;
    }
    if (values.grade > values.maxGrade) {
      errors.grade = `A nota do aluno deve ser menor ou igual a ${values.maxGrade}`;
    }
  }
  if (
    values.type === COMMUNICATION_TYPE.SURVEY ||
    values.type === COMMUNICATION_TYPE.AUTHORIZATION
  ) {
    if (!values.dueDate) {
      errors.dueDate = 'Esse campo não pode ficar vazio';
    }
  }

  return errors;
};

export default validate;
